// PackingRoutesXL - Sprint 44 Fase 3 Vista 7.
// Reemplaza modules/packing/routes.jsx. Rutas preservadas:
// /packing (index), /packing/:id (scan).
import { Routes, Route } from 'react-router-dom';
import PackingsListXL from './PackingsListXL';
import PackingScanXL from './PackingScanXL';

export default function PackingRoutesXL() {
  return (
    <Routes>
      <Route index element={<PackingsListXL />} />
      <Route path=":id" element={<PackingScanXL />} />
    </Routes>
  );
}
